export default __webpack_public_path__ + "static/media/tokenimgg.87a0e664.png";